import { constants } from "~/constants";
import { SupportedLanguage } from "~/features/intl/SupportedLanguage";
import { assert } from "~/utils/assert";

export function generateAlternateLinks(pathname: string) {
  const localeList = Object.values(SupportedLanguage);
  const defaultLocale = constants.DEFAULT_LANGUAGE;

  const url = `https://live.bokbok.io${pathname}`;
  const pathPartList = url.split("/");

  const alternateLinks = [];

  for (const locale of localeList) {
    // First we want to remove the langauge from the URL
    // and normalize it to the default language
    // Example: http://localhost/hr/terms-of-services > http://localhost/terms-of-services
    if (pathPartList.length >= 4) {
      const lang = pathPartList.at(3);

      if (lang === undefined) {
        throw new Error("No lang");
      }

      if (localeList.includes(lang as SupportedLanguage)) {
        pathPartList.splice(3, 1);
      }
    }
    // At this point we normalized the URL in pathPartList to the default language
    // Now we want to add the new language to the URL
    if (locale !== defaultLocale) {
      pathPartList.splice(3, 0, locale);
    }

    // We remove the trailing slash
    if (pathPartList.at(-1) === "") {
      pathPartList.pop();
    }

    // If the URL is just the domain, we add a trailing slash
    if (pathPartList.length === 3) {
      pathPartList.push("");
    }

    const href = pathPartList.join("/");

    alternateLinks.push({
      locale,
      href,
    });
  }

  // Add x-default alternate link
  const defaultLink = alternateLinks.find(
    (link) => link.locale === defaultLocale,
  );

  assert(!!defaultLink, "No defaultLink");

  alternateLinks.push({
    locale: "x-default",
    href: defaultLink.href,
  });

  return alternateLinks;
}
